import type { LngLat } from '../../types/Geo';
import StartEndMarker from './StartEndMarker';

type StartEndMarkersProps = {
  coordinates?: LngLat[];
};

/**
 * Route endpoint markers for the route the caller passes in. Collapses to a single combined marker
 * when the route is a loop (start and end coincide).
 */
const StartEndMarkers = ({ coordinates }: StartEndMarkersProps) => {
  if (!coordinates?.length) {
    return null;
  }

  const start = coordinates[0];
  const end = coordinates[coordinates.length - 1];

  if (start[0] === end[0] && start[1] === end[1]) {
    return <StartEndMarker latitude={start[1]} longitude={start[0]} variant="start-end" />;
  }

  return (
    <>
      <StartEndMarker latitude={start[1]} longitude={start[0]} variant="start" />
      <StartEndMarker latitude={end[1]} longitude={end[0]} variant="end" />
    </>
  );
};

export default StartEndMarkers;
